import {descending, ascending} from 'd3-array';
import { writable, readable, derived } from 'svelte/store';
import {fetchItem, fetchFeeds,fetchConfig } from './api.js'

const sorting = {
    descending,
    ascending
}

export const feeds = readable([], (set)=>{
    const fetchedFeeds = fetchFeeds();
    set(fetchedFeeds);
});

const config = readable({}, async (set)=>{
    const fetchedConfig = await fetchConfig();
    set(fetchedConfig);
});

export const account = derived(config,async($config, set)=>{
    if($config.account){
        const account = await fetchItem($config.account)
        set(account)
    }
})

export const sort = writable('mtime|ascending') 
export const filter = writable()

export const tracks = derived([feeds, sort, filter],([$feeds, $sort, $filter], set)=>{
    return (async()=>{
        const feeds = await $feeds;
        const allTracks = feeds
            .filter(d=>$filter?d.metadata.identifier === $filter :true)
            .map(d=>{
                const mp3s = d.files
                    .filter(d=>d.format === 'VBR MP3')
                    .map(f=>{
                        const thumbName = f.name.replace('.mp3','_thumb')
                        const thumbImage = d.files.filter(i=>i.name.replace(/\.jpg|\.jpeg|\.png|\.gif/i,'') === thumbName)[0]
                        const itemThumb = d.files.filter(i=>i.source === 'original' && i.format.match(/JPG|JPEG|PNG|GIF|Item Image/gm))[0]
                        f.cover = thumbImage?thumbImage:itemThumb
                        f.identifier = d.metadata.identifier
                        f.identifierTitle = d.metadata.title
                        return f
                    })
                return mp3s
            })
            .flat()
            .sort((a,b)=>sorting[$sort.split("|")[1]](a[$sort.split("|")[0]].toLowerCase(), b[$sort.split("|")[0]].toLowerCase()))

        set(allTracks)
    })()

},[])

export const playingTrack = writable()
